import React from "react";
import Forbidden from "../Pages/Forbidden";
import { moduleName, getLocalItem } from "../Constant/common";

// Modules that only SuperAdmin can access regardless of permissions
const SUPERADMIN_ONLY_MODULES = [moduleName.Organization];

const ProtectedRoute = ({ path, element, routes }) => {
  const activePermissions = JSON.parse(getLocalItem("permissions")) || [];
  const allowedModules = activePermissions?.map(({ module_name }) => module_name);
  const route = routes?.find((r) => r.path === path);

  if (route) {
    // Public routes — always accessible
    if (
      Array.isArray(route?.module_name)
        ? route?.module_name.includes(moduleName.Public)
        : route?.module_name === moduleName.Public
    ) {
      return element;
    }

    // SuperAdmin-only routes — block non-SuperAdmin regardless of permissions
    const routeModules = Array.isArray(route?.module_name)
      ? route.module_name
      : [route.module_name];

    const userRole = getLocalItem("role");
    // Block SuperAdmin from accessing Payroll and Overtime routes
    if (
      userRole === "SuperAdmin" &&
      (routeModules.includes(moduleName.Payroll) ||
        routeModules.includes(moduleName.OvertimeRequests))
    ) {
      return <Forbidden />;
    }

    const isSuperAdminOnly = routeModules.some((m) => SUPERADMIN_ONLY_MODULES.includes(m));
    if (isSuperAdminOnly && userRole !== "SuperAdmin") {
      return <Forbidden />;
    }

    const hasAccess = (() => {
      if (userRole === "SuperAdmin" || userRole === "Admin" || userRole?.startsWith("Admin")) {
        return true;
      }

      const isSupportRoute = Array.isArray(route?.module_name)
        ? route.module_name.includes(moduleName.Support)
        : route.module_name === moduleName.Support;

      if (isSupportRoute) {
        const hasSupportPermission = activePermissions?.some(
          (p) =>
            p?.parent_module_name?.trim()?.toLowerCase() === "support" ||
            p?.module_name?.trim()?.toLowerCase() === "support",
        );
        if (hasSupportPermission) return true;
      }

      return Array.isArray(route?.module_name)
        ? route?.module_name.some((module) =>
            allowedModules?.some(
              (allowed) => allowed?.trim()?.toLowerCase() === module?.trim()?.toLowerCase(),
            ),
          )
        : allowedModules?.some(
            (allowed) =>
              allowed?.trim()?.toLowerCase() === route?.module_name?.trim()?.toLowerCase(),
          );
    })();

    return hasAccess ? element : <Forbidden />;
  }

  return <Forbidden />;
};

export default ProtectedRoute;
